/**
 * @generated SignedSource<<0a11b3e5f65f8e2579ba9fa57bb31230>>
 * @relayHash 88febe19ed208f3255dd5d59e1e9ad41
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 88febe19ed208f3255dd5d59e1e9ad41

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "resetPasswordRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetPasswordRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetPasswordRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "88febe19ed208f3255dd5d59e1e9ad41",
    "metadata": {},
    "name": "ResetPasswordRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "093d95a42c358016b2817a93b31a46cd";

export default node;
